var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardGiftcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3921_1099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 5.00008H14.8501C14.9417 4.74175 15.0001 4.45841 15.0001 4.16675C15.0001 2.78341 13.8834 1.66675 12.5001 1.66675C11.6251 1.66675 10.8667 2.11675 10.4167 2.79175L10.0001 3.35008L9.58341 2.78341C9.13341 2.11675 8.37508 1.66675 7.50008 1.66675C6.11675 1.66675 5.00008 2.78341 5.00008 4.16675C5.00008 4.45841 5.05841 4.74175 5.15008 5.00008H3.33341C2.40841 5.00008 1.67508 5.74175 1.67508 6.66675L1.66675 15.8334C1.66675 16.7584 2.40841 17.5001 3.33341 17.5001H16.6667C17.5917 17.5001 18.3334 16.7584 18.3334 15.8334V6.66675C18.3334 5.74175 17.5917 5.00008 16.6667 5.00008ZM12.5001 3.33341C12.9584 3.33341 13.3334 3.70841 13.3334 4.16675C13.3334 4.62508 12.9584 5.00008 12.5001 5.00008C12.0417 5.00008 11.6667 4.62508 11.6667 4.16675C11.6667 3.70841 12.0417 3.33341 12.5001 3.33341ZM7.50008 3.33341C7.95841 3.33341 8.33341 3.70841 8.33341 4.16675C8.33341 4.62508 7.95841 5.00008 7.50008 5.00008C7.04175 5.00008 6.66675 4.62508 6.66675 4.16675C6.66675 3.70841 7.04175 3.33341 7.50008 3.33341ZM16.6667 15.8334H3.33341V14.1667H16.6667V15.8334ZM16.6667 11.6667H3.33341V6.66675H7.56675L5.83341 9.02508L7.18341 10.0001L9.16675 7.30008L10.0001 6.16675L10.8334 7.30008L12.8167 10.0001L14.1667 9.02508L12.4334 6.66675H16.6667V11.6667Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3921_1099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGiftcard);
export default __webpack_public_path__ + "static/media/card_giftcard.a0d0a744060b254474eaf7bec6987460.svg";
export { ForwardRef as ReactComponent };